import { render } from "./BroughtDocumentModal.vue?vue&type=template&id=f79555a0"
import script from "./BroughtDocumentModal.vue?vue&type=script&lang=js"
export * from "./BroughtDocumentModal.vue?vue&type=script&lang=js"

import "./BroughtDocumentModal.vue?vue&type=style&index=0&id=f79555a0&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__